import React, {Component} from "react"
import PropTypes from "prop-types"
import Button from '../../atoms/Button';

class ManageAgendaPeople extends Component {
  render() {
    const {dayId, people, allPeople} = this.props

    const peopleSorted = Object.keys(allPeople || {})
      .map(personId => {
        return {
          ...allPeople[personId],
          personId,
        }
      })
      .sort((a, b) => {
        if (a.name === b.name) return 0
        return a.name > b.name ? 1 : -1
      })

    const selectAll = () => {
      this.props.selectAll(dayId, Object.keys(allPeople))
    }

    const clearAll = () => {
      this.props.clearAll(dayId)
    }

    return (
      <div className="ManageAgendaPeople">
        <h2> People </h2>
        <div className="controls">
          <Button onClick={selectAll}>All</Button>
          <Button onClick={clearAll}>None</Button>
        </div>
        <div className="people">
          {peopleSorted.map(person => {
            const personId = person.personId
            const isActive = people.indexOf(personId) > -1
            const togglePerson = () => {
              if (isActive) {
                this.props.removePerson(dayId, personId)
              } else {
                this.props.addPerson(dayId, personId)
              }
            }
            return (
              <Button
                key={personId}
                onClick={togglePerson}
                selected={isActive}
                small
              >
                {person.name}
              </Button>
            )
          })}
        </div>
      </div>
    )
  }
}

ManageAgendaPeople.defaultProps = {
  people: [],
  allPeople: {},
}

ManageAgendaPeople.propTypes = {
  dayId: PropTypes.string.isRequired,
  people: PropTypes.arrayOf(PropTypes.string).isRequired,
  allPeople: PropTypes.object.isRequired,
  selectAll: PropTypes.func.isRequired,
  clearAll: PropTypes.func.isRequired,
  addPerson: PropTypes.func.isRequired,
  removePerson: PropTypes.func.isRequired,
}

export default ManageAgendaPeople



// WEBPACK FOOTER //
// ./src/component/organisms/ManageAgenda/ManageAgendaPeople.js